import { Outlet } from 'react-router-dom';

export default function PulseLayout() {
  return <Outlet />;
}
